import { render, staticRenderFns } from "./OrgUserRoleDialog.vue?vue&type=template&id=1de11c89&scoped=true&"
import script from "./OrgUserRoleDialog.vue?vue&type=script&lang=js&"
export * from "./OrgUserRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrgUserRoleDialog.vue?vue&type=style&index=0&id=1de11c89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de11c89",
  null
  
)

export default component.exports